import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    background: theme.palette.common.white,
    padding: 24,
    borderRadius: 8,
    marginBottom: 16,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    [theme.breakpoints.down(830)]: {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      background: theme.palette.common.white,
      padding: 24,
      boxShadow: 'none',
      borderRadius: 0,
    },
  },
  cardText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 8,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 16,
    },
  },
  darkBlue: {
    color: theme.palette.primary.dark,
    paddingRight: 12,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  status: {
    color: theme.palette.primary.main,
    padding: '4px 8px',
    borderRadius: 4,
    fontWeight: 500,
    fontSize: 14,
  },
  statusConfirmed: {
    background: theme.palette.primary.light,
  },
  statusRealised: {
    background: '#EDF9F2',
  },
}))
